export const response = {
	message: 'Ok',
	status_code: 200,
	success: true,
	data: [],
	paginator: {},
};
